import React from "react";

import {
    FiClock,
    FiEye,
    FiMail,
    FiPhone,
    FiUser,
    FiCreditCard,
} from "react-icons/fi";

import {
    formatCurrency,
    formatDate,
} from "../utils/customerLedgerUtils";

/*
|--------------------------------------------------------------------------
| COMPONENT
|--------------------------------------------------------------------------
*/

const CustomerWiseLedger = ({
    customers = [],
    loading = false,
    onViewCustomer,
    onReceivePayment
}) => {
    if (
        loading &&
        customers.length ===
        0
    ) {
        return (
            <div className="customer-ledger-customer-loading">
                Loading customers...
            </div>
        );
    }

    if (
        customers.length ===
        0
    ) {
        return (
            <div className="customer-ledger-customer-empty">
                <FiUser />

                <h3>
                    No customers found
                </h3>

                <p>
                    Customers with ledger activity will appear here.
                </p>
            </div>
        );
    }

    return (
        <div className="customer-wise-ledger-grid">
            {customers.map(
                (
                    customer
                ) => {
                    const hasOutstanding =
                        Number(
                            customer?.balance ||
                            0
                        ) >
                        0;

                    return (
                        <article
                            key={
                                customer?.key ||
                                customer?.customerId ||
                                customer?.mobile
                            }
                            className="customer-wise-ledger-card"
                        >
                            <div className="customer-wise-ledger-card-header">
                                <div className="customer-wise-ledger-profile">
                                    <span className="customer-wise-ledger-avatar">
                                        {String(
                                            customer?.name ||
                                            "C"
                                        )
                                            .charAt(
                                                0
                                            )
                                            .toUpperCase()}
                                    </span>

                                    <div>
                                        <h3>
                                            {customer?.name ||
                                                "Walk-in Customer"}
                                        </h3>

                                        <div className="customer-wise-ledger-contact">
                                            <span>
                                                <FiPhone />

                                                {customer?.mobile ||
                                                    "-"}
                                            </span>

                                            {customer?.email && (
                                                <span>
                                                    <FiMail />

                                                    {
                                                        customer.email
                                                    }
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <span
                                    className={
                                        hasOutstanding
                                            ? "customer-wise-ledger-status customer-wise-ledger-status-due"
                                            : "customer-wise-ledger-status customer-wise-ledger-status-clear"
                                    }
                                >
                                    {hasOutstanding
                                        ? "Outstanding"
                                        : "Clear"}
                                </span>
                            </div>

                            <div className="customer-wise-ledger-metrics">
                                <div>
                                    <span>
                                        Transactions
                                    </span>

                                    <strong>
                                        {customer?.entryCount ||
                                            0}
                                    </strong>
                                </div>

                                <div>
                                    <span>
                                        Debit
                                    </span>

                                    <strong className="customer-wise-ledger-debit">
                                        {formatCurrency(
                                            customer?.totalDebit ||
                                            0
                                        )}
                                    </strong>
                                </div>

                                <div>
                                    <span>
                                        Credit
                                    </span>

                                    <strong className="customer-wise-ledger-credit">
                                        {formatCurrency(
                                            customer?.totalCredit ||
                                            0
                                        )}
                                    </strong>
                                </div>

                                <div>
                                    <span>
                                        Balance
                                    </span>

                                    <strong
                                        className={
                                            hasOutstanding
                                                ? "customer-wise-ledger-balance customer-wise-ledger-balance-due"
                                                : "customer-wise-ledger-balance customer-wise-ledger-balance-clear"
                                        }
                                    >
                                        {formatCurrency(
                                            customer?.balance ||
                                            0
                                        )}
                                    </strong>
                                </div>
                            </div>

                            <div className="customer-wise-ledger-card-footer">
                                <span className="customer-wise-ledger-last-activity">
                                    <FiClock />

                                    Last activity:{" "}
                                    <strong>
                                        {formatDate(
                                            customer?.lastActivity,
                                            false
                                        )}
                                    </strong>
                                </span>

                                <div className="customer-ledger-card-actions">
                                    {Number(customer?.balance || 0) > 0 && (
                                        <button
                                            type="button"
                                            className="customer-ledger-receive-button"
                                            onClick={() =>
                                                onReceivePayment?.(
                                                    customer
                                                )
                                            }
                                        >
                                            <FiCreditCard />
                                            Receive Payment
                                        </button>
                                    )}

                                    <button
                                        type="button"
                                        className="customer-wise-ledger-view-button"
                                        onClick={() =>
                                            onViewCustomer(customer)
                                        }
                                    >
                                        <FiEye />
                                        View Customer Ledger
                                    </button>
                                </div>
                            </div>
                        </article>
                    );
                }
            )}
        </div>
    );
};

export default CustomerWiseLedger;